// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var StarRatingScale$ReactHooksTemplate = require("./StarRatingScale.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function StarRatingPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var starRating = props.starRating;
  var onTitleChange = function (html) {
    Curry._1(onChange, StarRating$ReactHooksTemplate.setText(starRating, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, StarRating$ReactHooksTemplate.setDescription(starRating, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: StarRating$ReactHooksTemplate.getTextTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: StarRating$ReactHooksTemplate.getDescriptionTranslation(starRating, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Ratings",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx(StarRatingScale$ReactHooksTemplate.make, {
                              starRating: starRating,
                              onChange: onChange,
                              layout: "Editor"
                            })
                      ],
                      className: "flex flex-col w-full"
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = StarRatingPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
